import {remCalc} from '../../_utils'

export default {
    baseStyle: {
        container: {
            mx: 'auto',
            w: '100%',
            textAlign: 'center',
            py: {base: 'medium.base', xl: 'medium.lg'},
            px: {base: remCalc(16), md: remCalc(24), xl: 0},
        },
        tabs: {
            display: {base: 'block', md: 'none'},
        },
        content: {
            maxW: {base: '100%', xl: remCalc(1400)},
            mx: {base: 0, xl: 'auto'},

            '.product-moodboard-swiper': {
                display: {md: 'flex'},
                flexDirection: {md: 'column-reverse'},
                gap: remCalc(24),
                overflow: 'hidden',
            },
            '.swiper-pagination-bullet-active': {
                textTransform: 'uppercase',
                textDecoration: 'underline',
                textUnderlineOffset: remCalc(4),
                color: 'text.default',
            },
            '.swiper-pagination-bullet': {
                background: 'none',
                w: 'auto',
                h: 'auto',
                m: `0 ${remCalc(13)}`,
                cursor: 'pointer',
            },

            '.img-container:hover img': {
                transform: 'scale(1.2)',
            },
        },
        pagination: {
            justifyContent: 'center',
            zIndex: 1,
            display: {base: 'none', md: 'flex'},
            textStyle: 'body-small',
            fontWeight: 'bold',
            color: 'text.secondary',
        },
        boardcontainer: {
            flexDirection: {base: 'column', lg: 'row'},
            alignItems: 'flex-start',
            justifyContent: 'flex-start',
            gap: {base: remCalc(8), md: remCalc(16), lg: remCalc(24)},
            alignSelf: 'stretch',
        },
        boardfirsthalf: {
            flexDirection: 'column',
            alignSelf: 'stretch',
            flex: '50%',
        },
        boardsecondhalf: {
            direction: 'column',
            justifyContent: 'flex-start',
            alignItems: 'flex-start',
            gap: {base: remCalc(8), md: remCalc(16), lg: remCalc(24)},
            alignSelf: 'stretch',
            flex: '50%',
        },
        boardtwoboxcontainer: {
            alignItems: 'flex-start',
            flexGrow: 1,
            alignSelf: 'stretch',
            gap: {base: remCalc(8), md: remCalc(16), lg: remCalc(24)},
        },
        productbox: {
            flexDirection: 'column',
            alignSelf: 'stretch',
            flexGrow: 1,
            justifyContent: 'flex-start',
            alignItems: 'center',
            bg: 'background.light',
            overflow: 'hidden',
            py: {base: remCalc(16), md: remCalc(24), lg: remCalc(40)},
            px: {base: remCalc(16), md: remCalc(24), lg: remCalc(40)},
            gap: {base: remCalc(8), md: remCalc(16)},
        },
        imagecontainer: {
            position: 'relative',
            overflow: 'hidden',
        },
        imageoverlay: {
            backgroundColor: 'rgba(0, 0, 0, 0.055)',
            position: 'absolute',
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
        },
        image: {
            w: {base: remCalc(311), md: remCalc(250), lg: remCalc(310), xl: remCalc(440)},
            h: {base: remCalc(250), md: remCalc(250), lg: remCalc(295), xl: remCalc(440)},
            transition: 'transform 0.7s ease-in-out',
        },
        textbox: {
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
        },
        productId: {
            textStyle: 'body-xxsmall',
            fontWeight: 'bold',
            textTransform: 'uppercase',
            color: 'text.secondary',
            pb: remCalc(4),
        },
        productName: {
            textStyle: 'body-large',
            fontWeight: 'bold',
            pb: remCalc(8),
        },
        price: {
            textStyle: 'body-large',
            fontWeight: 'normal',
        },
        omnibusPrice: {
            maxW: '100%',
            mt: remCalc(4),
        },
    },
    variants: {
        mediumTile: {
            productbox: {
                flexDirection: 'row',
                alignItems: 'flex-start',
                alignSelf: 'stretch',
                py: {base: remCalc(16), md: remCalc(16), lg: remCalc(16)},
                px: {base: remCalc(16), md: remCalc(40), lg: remCalc(40)},
            },
            imagecontainer: {
                display: 'flex',
                justifyContent: 'flex-end',
                flex: '50%',
                bg: 'background.default',
            },
            image: {
                w: {base: remCalc(130), md: remCalc(130), lg: remCalc(178), xl: remCalc(266)},
                h: {base: remCalc(130), md: remCalc(130), lg: remCalc(178), xl: remCalc(266)},
            },
            textbox: {
                alignSelf: 'stretch',
                flex: '50%',
            },
        },
        smallTile: {
            productbox: {
                flex: '50%',
                gap: {base: remCalc(8), md: remCalc(8)},
                py: {base: remCalc(16), md: remCalc(16), lg: remCalc(16)},
                px: {base: remCalc(16), md: remCalc(16), lg: remCalc(16)},
            },
            image: {
                w: {base: remCalc(130), md: remCalc(130), lg: remCalc(110), xl: remCalc(164)},
                h: {base: remCalc(130), md: remCalc(130), lg: remCalc(100), xl: remCalc(164)},
            },
        },
    },
    parts: ['productbox', 'image', 'imagecontainer', 'textbox'],
}
